export type DAYS = 'MON' | 'TUE' | 'WED' | 'THU' |  'FRI' | 'SAT' | 'SUN';
export const DAYS_LABEL = {
  MON: 'lundi',
  TUE:  'mardi',
  WED:  'mercredi',
  THU:  'jeudi',
  FRI:  'vendredi',
  SAT:  'samedi',
  SUN:  'dimanche',
}

export type DayNotificationConfig = {
  MON : boolean,
  TUE : boolean,
  WED : boolean,
  THU : boolean,
  FRI : boolean,
  SAT : boolean,
  SUN : boolean,
  time: string,
}

export const DEFAULT_DAYS_NOTIFICATION_CONFIG: DayNotificationConfig = {
  MON : false,
  TUE : false,
  WED : false,
  THU : false,
  FRI : false,
  SAT : false,
  SUN : false,
  time: 'EVENING'
}
